/**
 * DepotsPanel - Inventario de depósitos
 *
 * @version 2.0
 * @module core/modules/waste/components/panels
 *
 * @description
 * Panel de inventario de depósitos usando BaseInventoryPanel.
 * Configuración definida en depots-inventory.config.ts
 */

import { BaseInventoryPanel } from '../../../../layouts/panels/LeftPanel';
import { depotsInventoryConfig } from '../../config/depots-inventory.config';

export function DepotsPanel(): JSX.Element {
  return <BaseInventoryPanel config={depotsInventoryConfig} />;
}
